import {Injectable} from '@angular/core';
import { ApiResponse, LazyCatalog } from 'compob2b-libs';
import {Observable} from 'rxjs';
import {map, share} from 'rxjs/operators';
import {CatalogService} from '../../../../../../compob2b-admin/src/app/cabinet/pim/catalog/catalog.service'
import {
  CatalogCategory
} from "../../../../../../compob2b-libs/src/lib/interfaces/CatalogSubcategories";

export const CATALOG_ROOT_ID = 34;

@Injectable({
  providedIn: 'root'
})
export class CustomerCatalogService extends CatalogService {

  get apiUrl() {
    return '/catalog';
  }

  initCatalogTree(): Observable<LazyCatalog[]> {
    return this.compoApiService.get<LazyCatalog[]>(`${this.apiUrl}/tree`)
      .pipe(
        map(response => response.data)
      );
  }

  getLazyChildren(id: number): Observable<LazyCatalog[]> {
    return this.compoApiService.get<LazyCatalog[]>(`${this.apiUrl}/tree/${id}`)
      .pipe(
        map(response => response.data),
        share()
      );
  }

  getCategoryById(categoryId: number): Observable<ApiResponse<CatalogCategory>> {
    return this.compoApiService
      .get<ApiResponse<CatalogCategory>>(`${ this.apiUrl }/${ categoryId }`)
      .pipe(
        map((response) =>
          response.data,
        ),
      );
  }

  getSubcategories(categoryId: number): Observable<ApiResponse<CatalogCategory>> {
    return this.compoApiService
      .get<ApiResponse<CatalogCategory>>(`${this.apiUrl}/cards/${categoryId}`)
      .pipe(
        map((response) =>
          response.data,
        ),
      );
  }
}
